<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الإهداء">
<h1><span dir="rtl">الإهداء</span></h1>
<p style="text-indent:01em;"><span dir="rtl">أهدي خلاصة هذا الكتاب إلى مَن أهدَتني الحياة، وعلَّمَتني كيف أناضل في سبيل تحقيق طموحي وأحلامي.</span></p>
<p><span dir="rtl">وإلى الشخص الذي أنار عتمة طريقي، وكان لي الصديق الوفِيَّ، أطال الله في عمرهما (إلى أمِّي وأبي).</span></p>
<p><span dir="rtl">وكيف أنسى مَن هُم انتصاراتي وأملي في هذه الدنيا؟!</span></p>
<p><span dir="rtl">إلى أختي الصغيرة القويَّة، وإلى إخوتي الخمسة الذين هم سَندي وضلعي الذي لا يميل في الحياة.</span></p>
<p><span dir="rtl">إلى القلَّة الذين استخلصتُهم في رحلة البحث عن ذاتي، الأوفياء هُم، وبالوعود صادقون، الرائعون الحقيقيُّون الذين لا يتغيَّرون مهما اختلفنا ومهما طال الزمن، مَن لهم مَوضع قَدم في قلبي (صديقاتي).</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?499760fa